import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import logger from '@/sc_utils/logger';
import './Toast.scss';

export default class Toast extends PureComponent {
  static propTypes = {
    content: PropTypes.string.isRequired,
    duration: PropTypes.number,
    onClose: PropTypes.func
  }

  static defaultProps = {
    duration: 1
  }

  componentDidMount() {
    if (this.props.duration) {
      setTimeout(() => {
        this.props.onClose();
      }, this.props.duration * 1000);
    }
  }

  render() {
    const { type= 'info' } = this.props
    return (
      <div className="toast-container">
            <div className="toast-body">
               <div className={`${type}`}>
                   <div className={`${type}-content`}></div>
               </div>
                <div className="handle-content">{this.props.content}</div>
            </div>
      </div>
    );
  }
}

let containerElement = null;

const destory = () => {
  if (containerElement) {
    ReactDOM.unmountComponentAtNode(containerElement);
    document.body.removeChild(containerElement);
  }
}

Toast.show = ({ content, duration, onClose, type="info" }) => {
  logger.debug(`[Success Toast]`);
  if (document.getElementById('toastContainer')) {
    document.getElementById('toastContainer').remove();
  }
  containerElement = document.createElement("div");
  containerElement.id = "toastContainer";
  document.body.appendChild(containerElement);

  const onCloseCallback = () => {
    destory();
    onClose && onClose();
  }

  ReactDOM.render(
    <Toast
      content={content}
      duration={duration}
      onClose={onCloseCallback}
      type={type}
    />,
    containerElement
  );
}

Toast.loading = (content, duration, onClose) => {
    Toast.show({ content, duration, onClose, type:'loading' })
}
Toast.info = (content, duration, onClose) => {
    Toast.show({ content, duration, onClose, type:'info' })
}
Toast.hide = () => {
    destory()
}

